window.$ = window.jQuery;
// import Router from "./utils/Router";

//Globals scripts
import globals from "./globals";


// Globals
import "../../partials/components/globals";

import "../../partials/components/collezioni";

// Sliders
import "../../partials/components/sliders";
// Accordions
import "../../partials/components/accordions";

import "../../partials/components/tabs";
// import "../../partials/components/tabs/gallery";
// import "../../partials/components/tabs/maps";
// import "../../partials/components/tabs/files";

// Maps
import "../../partials/components/maps";
// Timeline
import "../../partials/components/timelines";
// Video
import "../../partials/components/videos";
// Blocks
import "../../partials/components/blocks";
// Gallery
import "../../partials/components/galleries";
// Popups
import "../../partials/components/popups";



// heads
// import "../../partials/components/heads";

// Lazy
// import "../js/lazy/locomotive/locomotive";
// import "../js/lazy/lax/lax";
import "../js/lazy/Paroller/paroller";
import "../js/lazy/LoadAnimate/load-animate";

//woocommerce
import "../../woocommerce/js";

$(".form-toggle__form").hide();
$(".form-toggle__button").click(function(e) {
  e.preventDefault();
  $(this)
    .closest(".form-toggle")
    .find(".form-toggle__form")
    .slideToggle();
});

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {

    // On-page links
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $("html, body").animate(
          {
            scrollTop: target.offset().top - 80,
          },
          1000,
          function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) {
              // Checking if the target was focused
              return false;
            } else {
              $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          }
        );
      }

      // Controllo sull'hash del link
      if (this.hash === "#orari") {
        console.log("orari");
        event.preventDefault(); // Impedisce il comportamento predefinito del link

        $(".menu-tendina").addClass("menu-tendina--active");
        $(".backplate").addClass("backplate--open");
        $(".hamburger").addClass("is-active");

        $(".lista-orari").addClass("lista-orari--active");
        $(".menu-tendina").addClass("menu-tendina--orari");
      } else {
          $(".menu-tendina").removeClass("menu-tendina--active");
          $(".backplate").removeClass("backplate--open");
          $(".hamburger").removeClass("is-active");
          $(".lista-orari").removeClass("lista-orari--active");
          $(".menu-tendina").removeClass("menu-tendina--orari");
      }


    }
  });

// new Router([
//   // {
//   //   attribute: ".swiper-container",
//   //   instance: Swiper,
//   // },
//   // {
//   //   attribute: ".page-storia",
//   //   instance: Storia,
//   // },
//   // {
//   //   attribute: ".testo-home",
//   //   instance: Testo,
//   // },
//   // {
//   //   attribute: ".scroll-reveal",
//   //   instance: "ScrollMagic/scrollmagic-reveal.js",
//   //   fn: () => {},
//   // },
// ]).watch();

// import Rellax from "rellax";

// var rellax = new Rellax(".rellax", {
//   center: true,
// });
// var rellaxShop = new Rellax(".rellax-shop", {
//   center: false,
// });

// window.onload = function() {
//   jQuery(".presentation-category__img-wrapper").addClass("loaded");
//   rellax.refresh();
//   rellaxShop.refresh();
// };

// let parent = document.querySelector('.sticky').parentElement;

// while (parent) {
//     const hasOverflow = getComputedStyle(parent).overflow;
//     if (hasOverflow !== 'visible') {
//         console.log(hasOverflow, parent);
//     }
//     parent = parent.parentElement;
// }
